<template>
  <div class="page-box">
    <PageSwiper location="CONTACT" />

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div style="cursor: pointer" @click="gotoHome">首页 ></div>
      <div class="text">联系我们</div>
    </div>

    <div class="contact">
      <div class="base">
        <div class="left">
          <div class="row-item">
            <div class="row-label tel-label">电话：</div>
            <div class="row-value phone-list">
              <div v-for="(item, index) in contactInfo.telList" :key="index" class="phone-item">
                <span class="phone-num">{{ item.num }}</span>
                <span class="phone-tag">{{ item.tag }}</span>
              </div>
            </div>
          </div>
          <div class="row-item">
            <div class="row-label map-label">地址：</div>
            <div class="row-value address-list">
              <div v-for="(item, index) in contactInfo.addressList" :key="index" class="address-item">
                <span class="address-name">{{ item.name }}：</span>
                <span class="address-text">{{ item.address }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="img-item">
            <div class="img-box">
              <img :src="$utils.getFileHttpUrl(baseConf.mpQr)" />
            </div>
            <div class="text">扫码关注公众号</div>
          </div>
          <div class="img-item" style="padding-left: 40px">
            <div class="img-box">
              <img :src="$utils.getFileHttpUrl(baseConf.miniQr)" />
            </div>
            <div class="text">微信小程序下单</div>
          </div>
        </div>
      </div>

      <div v-for="item in contactInfo.addressList" :key="item.key" class="map-section">
        <div class="map-title">{{ item.name }}地址</div>
        <div :id="'map-' + item.key" class="map-box"></div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      baseConf: {},
      contactInfo: {
        telList: [
          { num: '400-028-1983', tag: '全国统一客服热线' },
          { num: '0831-2022888', tag: '（宜宾）子公司电话' },
          { num: '028-87308888', tag: '（成都）总公司电话' },
          { num: '028-87308777', tag: '（成都）总公司电话' }
        ],
        addressList: [
          {
            key: 'chengdu',
            name: '成都总公司',
            address: '四川省成都市青羊区双锦路51号1栋1层7号',
            lon: 104.057,
            lat: 30.674
          },
          {
            key: 'yibin',
            name: '宜宾子公司',
            address: '四川省宜宾市翠屏区五新广场A座13楼1-2号',
            lon: 104.62031582804993,
            lat: 28.777600150037387
          },
          {
            key: 'chongqing',
            name: '重庆分公司',
            address: '重庆市两江新区大竹林街道星光大道62号海王星科技大厦D区8层20#8-1(068）',
            lon: 106.5098,
            lat: 29.6146
          }
        ]
      }
    }
  },
  mounted() {
    this.getBaseConf()
  },
  methods: {
    gotoHome() {
      this.$router.replace({ name: 'home' })
    },
    getBaseConf() {
      this.$http.getAction('/portal/api/v1/index/base/conf').then((res) => {
        if (res.success) {
          this.baseConf = res.data
          if (res.data.lon && res.data.lat) {
            const chengdu = this.contactInfo.addressList.find(item => item.key === 'chengdu')
            if (chengdu) {
              chengdu.lon = res.data.lon
              chengdu.lat = res.data.lat
            }
          }
          this.$nextTick(() => {
            this.initMaps()
          })
        }
      })
    },
    initMaps() {
      AMapLoader.load({
        key: 'dfd5085c2c4a5e72276d8959c052a918',
        version: '2.0'
      })
        .then((AMap) => {
          this.contactInfo.addressList.forEach((item) => {
            const container = document.getElementById('map-' + item.key)
            if (!container) return
            const map = new AMap.Map(container, {
              viewMode: '2D',
              zoom: 16,
              center: [item.lon, item.lat]
            })
            const marker = new AMap.Marker({
              position: [item.lon, item.lat]
            })
            map.add(marker)
          })
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 60px;

  .page-nav {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    line-height: 16px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
      cursor: pointer;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .contact {
    width: 1200px;
    margin: 0 auto;
    .base {
      margin-top: 40px;
      padding: 34px 70px 30px 70px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        padding-right: 40px;
        .row-item {
          display: flex;
          font-weight: 500;
          font-size: 16px;
          color: #666666;
          & + .row-item {
            margin-top: 24px;
          }
          .row-label {
            height: 24px;
            position: relative;
            flex-shrink: 0;
            &::before {
              position: absolute;
              left: -40px;
              top: 0;
              content: '';
              width: 20px;
              height: 20px;
              background-size: cover;
            }
          }
          .tel-label {
            &::before {
              background-image: url(../assets/tel-icon.png);
            }
          }
          .map-label {
            &::before {
              background-image: url(../assets/map-icon.png);
            }
          }
          .row-value {
            flex: 1;
          }
          .phone-list {
            display: flex;
            flex-wrap: wrap;
            .phone-item {
              width: 50%;
              height: 24px;
              line-height: 24px;
              margin-bottom: 14px;
              .phone-num {
                font-weight: 500;
                font-size: 16px;
                color: #666666;
              }
              .phone-tag {
                margin-left: 8px;
                font-weight: 500;
                font-size: 14px;
                color: #999999;
              }
            }
          }
          .address-list {
            .address-item {
              min-height: 24px;
              line-height: 24px;
              margin-bottom: 14px;
              .address-name {
                font-weight: 500;
                font-size: 16px;
                color: #666666;
              }
              .address-text {
                font-weight: 500;
                font-size: 14px;
                color: #666666;
              }
            }
          }
        }
      }
      .right {
        display: flex;
        .img-item {
          width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .img-box {
            width: 120px;
            height: 120px;
            object-fit: cover;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid rgba(107, 119, 154, 0.15);
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .text {
            margin-top: 10px;
            font-weight: 500;
            font-size: 14px;
            color: #282626;
            line-height: 16px;
            text-align: center;
          }
        }
      }
    }

    .map-section {
      margin-top: 40px;
      .map-title {
        margin-bottom: 20px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        text-align: center;
      }
      .map-box {
        width: 1200px;
        height: 500px;
      }
    }
  }
}
</style>
